module.exports = __webpack_public_path__ + "img/ed.4d8f5234.svg";